"use strict";

exports.__esModule = true;
exports.default = getEvenValues;
function getEvenValues(list, index) {
    return index % 2 === 0;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/cssnano/dist/lib/evenValues.js
// module id = 700
// module chunks = 0